import { render, staticRenderFns } from "./AdminContrattiAttiviView.vue?vue&type=template&id=924cb8de&"
import script from "./AdminContrattiAttiviView.vue?vue&type=script&lang=ts&"
export * from "./AdminContrattiAttiviView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports